<template>
  <div
    class="config-index"
    :class="{'config-index-english': $isEnglish}"
  >
    <h1 class="title">
      {{ $t('message["1326"]') }}
    </h1>
    <div
      v-if="Object.keys(permissions).length <= 0"
      class="loading"
    >
      <a-spin />
    </div>
    <div v-else>
      <div class="config-item-box">
        <h2 class="config-item-tit">
          {{ $t('message["1375"]') }}
        </h2>
        <div class="config-item-list">
          <ul class="clearfix">
            <router-link
              v-if="permissions['config-inquiry-submit']"
              tag="li"
              :to="{ name: 'configCollect' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test53 normal-color " />
                <h3>{{ $t('message["1173"]') }}</h3>
                <p>{{ $t('message["698"]') }}</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-inquiry-from']"
              tag="li"
              :to="{ name: 'configreferrer' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test55 success-color" />
                <h3>{{ $t('message["1371"]') }}</h3>
                <p>{{ $t('message["701"]') }}</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-inquiry-relation']"
              tag="li"
              :to="{ name: 'configRelationList' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test52 pur-color" />
                <h3>{{ $t('message["1365"]') }}</h3>
                <p>{{ relationText }}</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-inquiry-followup']"
              tag="li"
              :to="{ name: 'configVisit' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test61 warn-color" />
                <h3>{{ $t('message["445"]') }}</h3>
                <p>{{ $t('message["708"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-sensitive']"
              tag="li"
              :to="{ name: 'configSensitive' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test46 warn-color" />
                <h3>{{ $t('message["645"]') }}</h3>
                <p>{{ $t('message["703"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-check-repeat']"
              tag="li"
              :to="{ name: 'configRepeat' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test76 normal-color" />
                <h3>{{ $t('message["1357"]') }}</h3>
                <p>{{ $t('message["706"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-allocate-rule']"
              tag="li"
              :to="{ name: 'configRule', query: {tab: 'setmethod'} }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test93 pur-color" />
                <h3>
                  {{ $t('message["1362"]') }}
                  <!-- <em class="new-ico2" /> -->
                </h3>
                <p>{{ $t('message["707"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-set-bulkimport'] && $store.state.baseinfo.vip"
              tag="li"
              :to="{ name: 'configImportList' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconpiliangdaoru warn-color" />
                <h3>
                  {{ $t('message["710"]') }}
                </h3>
                <p>{{ $t('message["577"]') }}</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-inquiry-submit']"
              tag="li"
              :to="{ name: 'configClue' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconxiaoshouxiansuopeizhi danger-color " />
                <h3>线索配置</h3>
                <p>配置销售线索的追踪、分配和录入</p>
              </div>
            </router-link>
          </ul>
        </div>
      </div>
      <div
        v-if="showConfig"
        class="config-item-box"
      >
        <h2 class="config-item-tit">
          {{ $t('message["1214"]') }}
        </h2>
        <div class="config-item-list">
          <ul
            ref="commonConfig"
            class="clearfix"
          >
            <router-link
              v-if="permissions['config-role-manage']"
              tag="li"
              :to="{ name: 'RoleManagement' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test50 success-color " />
                <h3>{{ $t('message["505"]') }}</h3>
                <p>{{ $t('message["1667"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-team']"
              tag="li"
              :to="{ name: 'TeamIndex' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test56 normal-color" />
                <h3>{{ $t('message["1228"]') }}</h3>
                <p>{{ $t('message["702"]') }} 。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-notice']"
              tag="li"
              :to="{ name: 'configNotice' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test51 danger-color" />
                <h3>{{ $t('message["1218"]') }}</h3>
                <p>{{ $t('message["1010"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-set-logo'] && !!$store.state.baseinfo.vip"
              tag="li"
              :to="{ name: 'configLogo' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test71 pur-color" />
                <h3>{{ $t('message["1318"]') }}logo</h3>
                <p>{{ $t('message["1666"]') }}logo。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-form']"
              tag="li"
              :to="{ name: 'configSmart' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test91 normal-color" />
                <h3>{{ $t('message["1246"]') }}</h3>
                <p>{{ $t('message["700"]') }}</p>
              </div>
            </router-link>
            <li
              v-if="permissions['config-ocpc'] && !$isDingDing"
              @click="enterOcpc"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconOCPC danger-color" />
                <h3>oCPC{{ isEnglish ? '' : $t('message["1008"]') }}</h3>
                <p>{{ $t('message["1208"]') }}。</p>
              </div>
              <up-ocpc-grade-tip
                ref="ocpcUpgradeTip"
                type="up"
              />
            </li>
            <router-link
              v-if="permissions['config-set-list']"
              tag="li"
              :to="{ name: 'configListSet' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconliebiaoxianshipeizhi pur-color" />
                <h3>{{ $t('message["609"]') }}</h3>
                <p>{{ $t('message["1024"]') }}</p>
              </div>
            </router-link>
            <!-- 列表视图设置 -->
            <li
              v-if="permissions['config-view']"
              @click="handleEnterListView"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconliebiaoshitushezhi pur-color" />
                <h3>{{ $t('message[1911]') }}</h3>
                <!-- 为各个信息列表设置不同的快捷视图。 -->
                <p>{{ $t('message["1924"]') }}</p>
              </div>
            </li>
            <!-- 自动回收 -->
            <router-link
              v-if="permissions['config-auto-recycle']"
              tag="li"
              :to="{ name: 'configWithdraw' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconyewuguizepeizhi normal-color" />
                <h3>{{ $t('message["1729"]') }}</h3>
                <p>{{ $t('message["1730"]') }}</p>
              </div>
            </router-link>
            <!-- 电视大屏 -->
            <li
              v-if="permissions['config-tv']"
              @click="handleEnterTv"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconshujudaping danger-color" />
                <h3>{{ $t('message["1783"]') }}</h3>
                <p>{{ $t('message["1784"]') }}</p>
              </div>
            </li>
            <router-link
              v-if="permissions['config-project-relate']"
              tag="li"
              :to="{ name: 'RelatedProject' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconman normal-color" />
                <h3>关联项目</h3>
                <p>关联至会员管理项目，自动根据询盘数据创建会员。</p>
              </div>
            </router-link>
          </ul>
        </div>
      </div>
      <div
        v-if="permissions['config-pay-message'] || permissions['config-pay-email'] || permissions['config-service-upgrade']"
        class="config-item-box"
      >
        <h2 class="config-item-tit">
          {{ $t('message["313"]') }}
        </h2>
        <div class="config-item-list">
          <ul class="clearfix">
            <router-link
              v-if="permissions['config-pay-message'] && !$isDingDing"
              tag="li"
              :to="{ name: 'ServiceSms' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test48 success-color " />
                <h3>{{ $t('message["252"]') }}</h3>
                <p>{{ $t('message["1287"]') }}。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-pay-email'] && !$isDingDing"
              tag="li"
              :to="{ name: 'ServiceEmail' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test58 normal-color" />
                <h3>{{ $t('message["1502"]') }}</h3>
                <p>{{ $t('message["1288"]') }} 。</p>
              </div>
            </router-link>
            <router-link
              v-if="permissions['config-service-upgrade']"
              tag="li"
              :to="{ name: 'configService' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconicon-test44 danger-color" />
                <h3>{{ $t('message["312"]') }}</h3>
                <p>{{ $t('message["1083"]') }}。</p>
              </div>
            </router-link>
            <li
              v-if="permissions['config-webhook']"
              @click="joinWebhook"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconWebhook pur-color" />
                <h3>Webhook</h3>
                <p>借助Webhook功能可以将星轨上的一些事件推送至企微、钉钉等其他系统。</p>
              </div>
              <upgrade-tip
                ref="upgradeTip"
                type="up"
              />
            </li>
            <router-link
              v-if="permissions['config-xiaoman'] && !!$store.state.baseinfo.xiaoman_isopen"
              tag="li"
              :to="{ name: 'XiaomanBaseConfig' }"
            >
              <div class="config-item-cell">
                <i class="icon iconfont iconman normal-color" />
                <h3>小满集成</h3>
                <p>正在使用小满产品，可以将星轨数据同步至小满。</p>
              </div>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="config-item-box op-log-box">
        <h2 class="config-item-tit">
          {{ $t('message["82"]') }}
        </h2>
        <template v-if="workList.length > 0">
          <div
            v-for="item in workList"
            :key="item.date"
            class="log-item"
          >
            <h4>{{ item.date }} {{ item.day }}</h4>
            <div class="log-item-con">
              <div
                v-for="(data,key) in item.child"
                :key="key"
                class="log-i"
                :class="{'border0':key==0}"
              >
                <p><em>{{ data.time }}</em><span>{{ data.truename }}</span>{{ $t('message["380"]') }}<span>{{ data.configtype }}</span></p>
              </div>
            </div>
          </div>
          <div class="more-btn">
            <a-button
              v-if="list.length > 9"
              :disabled="loading"
              :loading="loading"
              class="gray-btn"
              @click="loadMoreHandle"
            >
              {{ $t('message["472"]') }}
            </a-button>
          </div>
        </template>
        <template v-else>
          <p class="null_data">
            {{ $t('message["1553"]') }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import UpgradeTip from '@/components/pc/config/webhook/WebTipDialog'
import UpOcpcGradeTip from './ocpc/components/OcpcTipDialog'
import { getLang } from '@/lib/storage'
// const maps = this.weeks //['周日', '周一', '周二', '周三', '周四', '周五', '周六']

export default {
  name: 'Index',
  components: {
    UpgradeTip,
    UpOcpcGradeTip
  },
  data () {
    return {
      loading: false,
      page: 1,
      list: [],
      permissions: {},
      showConfig: true
    }
  },
  computed: {
    workList () {
    // const { datas = [] } = state
      const { list = [] } = this
      const arr = []
      const objs = {}
      if (list.length > 0) {
        list.forEach(item => {
          const time = item.addtime * 1000
          const dt = new Date(time)
          const key = dt.toLocaleDateString().replace(/\//g, '-')
          item.time = this.$moment(time).format('HH:mm:ss')
          if (!objs[key]) {
            objs[key] = []
            arr.push({
              date: key,
              day: this.weeks[dt.getDay()],
              child: objs[key]
            })
          }
          objs[key].push(item)
        })
      } else {
        return []
      }
      return arr
    },
    baseinfo () {
      return this.$store.state.baseinfo
    },
    relationText () {
      const systemRole = this.baseinfo.level_role
      if (systemRole === 1) { // 负责人
        return this.$t('message["704"]')
      } else if (systemRole === 2) { // 主管
        return this.$t('message["699"]')
      } else if (systemRole === 3) { // 组长
        return this.$t('message["705"]')
      } else if (systemRole === 4) { // 普通成员
        return this.$t('message["709"]')
      } else {
        return this.$t('message["697"]')
      }
    },
    weeks () {
      return this.$t('message["1628"]').split(',')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    baseinfo (val) {
      const commonConfig = this.$refs.commonConfig
      if (commonConfig) {
        this.showConfig = commonConfig.children && commonConfig.children.length > 0
      }
    }
  },
  async created () {
    await this.getDatas()
  },
  methods: {
    ...mapActions('config/configIndex', ['fetchOperaLogDatas']),
    getLang,
    async getDatas () {
      this.loading = true
      const chain = await this.fetchOperaLogDatas()
      chain.params({ page: this.page })
        .onSuccess((res, data) => {
          this.permissions = Object.assign({}, data.permissions)
          if (res.length > 0) {
            this.list.push(...res)
            this.page++
          } else {
            // this.$message.warning('日志已加载完')
          }

          document.title = this.$t('message["1326"]') + ' - ' + data.baseinfo.projectname + '-' + data.baseinfo.comname
          this.loading = false
        })
        .fetch()
    },
    async loadMoreHandle () {
      await this.getDatas()
    },
    joinWebhook () {
      if (!this.baseinfo.vip) {
        this.$refs.upgradeTip.changeLimitDialog(true)
      } else {
        this.$router.push({ name: 'configWebhookList' })
      }
    },
    enterOcpc () {
      if (!this.baseinfo.vip) {
        this.$refs.ocpcUpgradeTip.changeLimitDialog(true)
      } else {
        this.$router.push({ name: 'ocpc' })
      }
    },
    handleEnterTv () {
      if (!this.baseinfo.vip) {
        this.$confirm({
          title: this.$t('message[1816]'),
          content: this.$t('message[1817]'),
          closable: true,
          okText: this.$t('message[599]'), // '立即升级'
          okType: 'primary',
          cancelText: this.$t('message[1005]'), // '稍后进行',
          class: 'confirm-warn-modal',
          onOk: async () => {
            this.$router.push({ name: 'ServiceIndex' })
          }
        })
      } else {
        this.$router.push({ name: 'configTvList' })
      }
    },
    handleEnterListView () {
      this.$router.push({ name: 'configListView' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .config-index::v-deep {
    .config-item-tit {
      height: 48px;
      line-height: 48px;
      border-top: 1px solid #ebebeb;
      font-size: 18px;
      margin-bottom: 24px;
      margin-top: 10px;
      font-weight: 500;
    }
    .config-item-list {
      width:1078px;
      // width: 1038px;
      // overflow: hidden;
      // ul{
      //   width:1078px;
      // }
      li {
        width: 500px;
        border: 1px solid #ebebeb;
        border-radius: 4px;
        float: left;
        margin:0  37px 24px 0;
        cursor: pointer;
        .config-item-cell {
          margin: 16px;
          position: relative;
          padding-left: 56px;
          min-height: 40px;
          i {
            position: absolute;
            left: 0;
            width: 40px;
            height: 40px;
            font-size: 40px;
            top: 0
          }
          .normal-color {
            color: #4ca0f2;
          }
          .success-color {
            color: #42c27e;
          }
          .pur-color {
            color: #bd7ce8;
          }
          .warn-color {
            color: #f6a953;
          }
          .danger-color{
            color: #f57676;
          }

        }
        h3 {
          font-weight: 600;
          line-height: 24px;
          .new-ico2 {
          background: url(../../assets/images/newico2.png) no-repeat 0 0;
          background-size: 40px 23px;
          width: 40px;
          height: 23px;
          display:inline-block;
          vertical-align: middle;
        }
        }
        p {
          font-size: 12px;
          color: #b3b3b3;
          line-height: 16px;
        }
        .iconicon-test73 {
          position: absolute;
          right: 0;
          color: #d6d6d6;
          top: 6px;
        }
      }
      li:hover {
        box-shadow:0px 0px 16px 0px rgba(0,0,0,0.1);
      }
    }
    .log-item {
      h4 {
        line-height: 24px;
        padding: 12px 0;
        font-weight: 600;
      }
      .log-i {
        line-height: 48px;
        em {
          font-style: normal;
          margin-right: 8px;
        }
        span {
          color:#5077aa;
          margin-left: 16px;
          margin-right: 16px;
        }
      }
    }
    .gray-btn {
      margin: 20px 0 0;
    }
    .op-log-box {
      margin-bottom: 40px;
    }
  }
  .config-index-english {
    .config-item-list {
      li{
        min-height: 90px;
      }
    }
  }
  .null_data {
    color: #b3b3b3
  }
</style>
